import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="shift-unassign"
export default class extends Controller {
  connect() {
    console.log('shift-unassign connected')
  }

  handle(event){
    let target = document.getElementById("dashboard-shift-row-" + event.params.id)
    // console.log(event.params.id)
    target.classList.add('d-none')
  }
}

/*
###time slots management partial
<script type="module" class="unassigner-used-by-unassign_button">
  document.addEventListener('DOMContentLoaded', function() {
      var buttons = document.querySelectorAll('.shift-unassign-button');
      buttons.forEach(function(button) {
          button.addEventListener('click', function(e) {
              e.preventDefault(); // Prevent the default anchor action
              var targetId = button.getAttribute('data-bs-target');
              var targetDiv = document.getElementById(targetId);
              if (targetDiv) {
                  targetDiv.classList.add('d-none')
                  var parts = targetId.split('-');
                  var shiftId = parts[parts.length - 1];
                  var divId = "calendar-shift-assignment-note-" + shiftId
                  var secondTargetDiv = document.getElementById(divId);
              };
              if (targetDiv) {
                  try {
                      // hide participant's hours totals, since we'd need to update the math
                      document.getElementById('volunteer-hours').classList.add('d-none')
                  } catch (error) {
                      // Error handling logic
                      // console.error('An error occurred:', error.message);
                  };

                  try {
                      // hide participant's name/status within the calendar section after unassign is clicked at top
                      if (secondTargetDiv) {
                          secondTargetDiv.classList.add('d-none')
                      };
                  } catch (error) {
                      // Error handling logic
                      // console.error('An error occurred:', error.message);
                      debugger;
                  };
              };
          });
      });
  });
</script>
*/


/*
###self sign up weekly
<script type="module" class="unassigner-used-by-unassign_button">
      document.addEventListener('DOMContentLoaded', function() {
          var buttons = document.querySelectorAll('.shift-unassign-button');
          buttons.forEach(function(button) {
              button.addEventListener('click', function(e) {
                  e.preventDefault(); // Prevent the default anchor action
                  var targetId = button.getAttribute('data-bs-target');
                  var targetDiv = document.getElementById(targetId);

                  if (targetDiv) {
                      targetDiv.style.display = 'none';
                      var parts = targetId.split('-');
                      var shiftId = parts[parts.length - 1];
                      var divId = "calendar-shift-assignment-note-" + shiftId
                      var secondTargetDiv = document.getElementById(divId);
                  };
                  if (targetDiv) {
                      try {
                          // hide participant's hours totals, since we'd need to update the math
                          document.getElementById('volunteer-hours').style.display = 'none';
                      } catch (error) {
                          // Error handling logic
                          // console.error('An error occurred:', error.message);
                      };

                      try {
                          // hide participant's name/status within the calendar section after unassign is clicked at top
                          if (secondTargetDiv) {
                              secondTargetDiv.style.display = 'none';
                          };
                      } catch (error) {
                          // Error handling logic
                          // console.error('An error occurred:', error.message);
                          debugger;
                      };
                  };
              });
          });
      });
  </script>
*/